import {
  FETCH_POWER_USE_VS_GENERATION_REQUEST,
  FETCH_POWER_USE_VS_GENERATION_SUCCESS,
  FETCH_POWER_USE_VS_GENERATION_FAILURE,
} from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const powerUseVsGenerationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_POWER_USE_VS_GENERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_POWER_USE_VS_GENERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_POWER_USE_VS_GENERATION_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default powerUseVsGenerationReducer;
